import { user } from './api/entities';
import Constants from '../constants/constants';
import churnzeroService from '../services/churnzero/churnzero-service';
import actions from './user_actions';
import AuthService from '../services/auth/authService';

export function resetUserState() {
  return { type: actions.resetUserState };
}

export function createUser(userObject) {
  return user.create(actions.createUser, userObject, []);
}

export function updateUser(userId, userObject) {
  return user.update(actions.updateUser, userId, userObject, []);
}

export function getUsers(query, sort) {
  return user.list(actions.listUser, query, sort);
}

export function getUser(userId) {
  return user.get(actions.getUser, userId, []);
}

export function loginOfflineUser(offlineToken) {
  return { type: actions.loginOfflineUser, body: offlineToken };
}

export function login(userObject) {
  return { type: actions.login, body: userObject };
}

export function logout() {
  return { type: actions.logout };
}

export function userFromToken(userData) {
  return { type: actions.getUserFromToken, body: userData };
}

const INITIAL_STATE = {
  users: [],
  user: {},
  userLoggedIn: false,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.login:
    case actions.getUserFromToken: {
      if (action?.isLoading) {
        return { ...state, isLoading: true };
      }
      if (action.body && action.body._error) {
        if (action.body._error.code === Constants.HTTP_UNAUTHORIZED) {
          return { ...state, authErrorMessage: action.body._error.message, organization: null };
        }
      }

      const isSuperRole =
        action.body && action.body.role ? action.body.role.toLowerCase() === Constants.SUPER_ROLE : false;

      const isAdminRole =
        isSuperRole ||
        (action.body && action.body.role ? action.body.role.toLowerCase() === Constants.ADMIN_ROLE : false);

      const isTherapistRole =
        isAdminRole ||
        (action.body && action.body.role ? action.body.role.toLowerCase() === Constants.THERAPIST_ROLE : false);
      const is_impersonated = action.body ? action.body.is_impersonated : false;

      return {
        ...state,
        currentUserId: action.body ? action.body.userId : null,
        currentUserFirstName: action.body ? action.body.userFirstName : null,
        currentUserLastName: action.body ? action.body.last_name : null,
        role: action.body ? action.body.role : null,
        roleLevel: action.body ? action.body.roleLevel : null,
        limited: action.body ? action.body.limited : null,
        isSuperRole: isSuperRole,
        isAdminRole: isAdminRole,
        isTherapistRole: isTherapistRole,
        organization: action.body ? action.body.organization : null,
        isMasquaraded: is_impersonated,
        authErrorMessage: '',
        requirePasswordChange: action.body ? action.body.password_change_flag : null,
        otpRequired: action.body ? action.body.otp_required : null,
        otpConfigured: action.body ? action.body.otp_number_available : null,
        otpPhoneTwoDigits: action.body ? action.body.otp_number_two_digits : null,
        isLoading: action?.isLoading,
        userLoggedIn: action.body && action.body.userId ? true : false,
        playerId: action.body ? action.body.player_id : null,
        realm_name: action.body ? action.body.realm_name : null,
      };
    }
    case actions.loginOfflineUser: {
      AuthService.clearAuth();
      return {
        ...state,
        currentUserId: null,
        currentUserFirstName: null,
        currentUserLastName: null,
        role: null,
        roleLevel: null,
        limited: false,
        isSuperRole: false,
        isAdminRole: false,
        isTherapistRole: false,
        organization: null,
        isMasquaraded: false,
        authErrorMessage: '',
        requirePasswordChange: null,
        otpRequired: null,
        otpConfigured: null,
        otpPhoneTwoDigits: null,
        userLoggedIn: false,
        realm_name: null,
      };
    }
    case actions.resetUserState: {
      return {
        ...state,
        user: {},
        userLoggedIn: false,
      };
    }
    case actions.createUser:
      return {
        ...state,
        users: action.body
          ? typeof state.users !== 'undefined'
            ? [...state.users, action.payload]
            : [action.payload]
          : state.users,
      };
    case actions.listUser:
      return {
        ...state,
        users: action.body ? action.body._items : state.users,
      };
    case actions.getUser:
      return {
        ...state,
        user: action.body ? action.body : state.user,
      };
    case actions.updateUser:
      return {
        ...state,
        id: action.body ? action.body : null,
      };
    case actions.keepAlive:
      return {
        ...state,
      };
    case actions.logout: {
      churnzeroService.logoutUser();
      AuthService.clearAuth();
      return {
        ...state,
        currentUserId: null,
        currentUserFirstName: null,
        currentUserLastName: null,
        role: null,
        roleLevel: null,
        limited: null,
        isSuperRole: false,
        isAdminRole: false,
        isTherapistRole: false,
        organization: null,
        isMasquaraded: false,
        userLoggedIn: false,
        realm_name: false,
      };
    }
    default:
      return {
        ...state,
      };
  }
}
